import { ApiError, ApiParameter } from "@insite/client-framework/Services/ApiService";

export interface apiResultModel {
    result: any;
}

export interface ExportHistoryFileParameter extends ApiParameter {
    reportFormat?: string;
    url?: string;
    fileName?: string;
}

export async function getFile(parameter: ExportHistoryFileParameter) {
    const response = await fetch(`${parameter.url}`);

    try {
        const blob = response.ok && (await response.blob());
        if (!response.ok) {
            throw new Error(
                JSON.stringify({
                    status: response.status,
                    errorJson: {
                        message: response.statusText,
                    },
                }),
            );
        }
        return blob;
    } catch (error) {
        let message: string;
        let errorJson: any;
        if (response.headers.get("Content-Type")?.startsWith("application/json")) {
            errorJson = (await response.json()) as { message: string; exceptionMessage?: string };
            message = errorJson.exceptionMessage ?? errorJson.message;
        } else {
            message = await response.text();
        }
        throw new ApiError(`${parameter.url}`, response, message, errorJson);
    }
}